import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '~/components/App';
import { profilerInit } from '~/lib/profiler';
import { sentryInit } from '~/lib/sentry';
import { store } from '~/store/store';

await store.getActions().features.loadFeatures();
profilerInit();
sentryInit();

const container = document.getElementById('root')!;
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
